var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('c-box', {
    attrs: {
      "w": "full",
      "h": "full"
    }
  }, _vm._l(_vm.menus, function (menu) {
    return _c('CardDiet', {
      key: menu.id,
      attrs: {
        "menu": menu
      }
    });
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }